import React, { useState } from 'react';
import obTop from '../../assets/webp-images/ob-top.png';
import backArrow from '../../assets/arrow-back.svg';
import { useNavigate } from 'react-router-dom';
import ChallengeObWelcome from './components/ChallengeObWelcome';
import ChallengeObHabit from './components/ChallengeObHabit';
import ChallengeObLessons from './components/ChallengeObLessons';
import ChallengeObAnytime from './components/ChallengeObAnytime';
import ChallengeObImpact from './components/ChallengeObImpact';
import ChallengeObCommunity from './components/ChallengeObCommunity';
import ChallengeObConsistency from './components/ChallengeObConsistency';
import ChallengeObAfter from './components/ChallengeObAfter';
import ChallengeObName from './components/ChallengeObName';
import ChallengeObNumber from './components/ChallengeObNumber';
import { signUpUser, updateUser } from '../../services/Firebase';
import { Mixpanel } from '../../analytics/Mixpanel';
import { addUsers } from '../../store/features/AuthSlice';
import { useDispatch } from 'react-redux';

import './ChallengeOnboarding.css';

const ChallengeOnboarding = () => {
	const [screenIndex, setScreenIndex] = useState<number>(0);
	const [number, setNumber] = useState<string>('');
	const [userName, setUserName] = useState<string>('');
	const [loader, setLoader] = useState<boolean>(false);

	const navigate = useNavigate();
	const dispatch = useDispatch();

	const onBack = () => {
		if (screenIndex > 0) {
			setScreenIndex((prev) => prev - 1);
			return;
		}

		navigate('/');
	};

	const onContinue = async () => {
		if (screenIndex < 8) {
			setScreenIndex((prev) => prev + 1);
			return;
		}

		try {
			setLoader(true);
			const userSignUpResult = await signUpUser(
				{ name: userName, phone: number, source: 'WEB' },
				'SIGNUP'
			);
			setLoader(false);

			if (userSignUpResult) {
				updateUser(userSignUpResult.userId, {
					isPlanOnboardingComplete: true,
				});
				Mixpanel.identify(userSignUpResult.userId);
				Mixpanel.people.set({
					$id: userSignUpResult.userId,
					$name: userName,
					$phone: number,
				});
				Mixpanel.track('SignUp', {
					$id: userSignUpResult.userId,
					$name: userName,
					$phone: number,
				});
				Mixpanel.track('view_account_created_screen', {
					event_page: 'account_created',
					event_action: 'viewed',
				});
				dispatch(addUsers(userSignUpResult.userData));
				localStorage.setItem('user', JSON.stringify(userSignUpResult.userData));
				navigate('/plan/subscribe');
			} else {
				setLoader(false);
			}
		} catch (e) {
			console.log('signup error:', e);
		}
	};

	return (
		<div className='challenge-ob'>
			<img className='challenge-ob-top' src={obTop} alt='' />
			<div className='challenge-ob-container'>
				<img
					className='challenge-ob-back'
					src={backArrow}
					onClick={onBack}
					alt=''
				/>
				{screenIndex === 0 && <ChallengeObWelcome onContinue={onContinue} />}
				{screenIndex === 1 && <ChallengeObHabit onContinue={onContinue} />}
				{screenIndex === 2 && <ChallengeObLessons onContinue={onContinue} />}
				{screenIndex === 3 && <ChallengeObAnytime onContinue={onContinue} />}
				{screenIndex === 4 && <ChallengeObImpact onContinue={onContinue} />}
				{screenIndex === 5 && <ChallengeObCommunity onContinue={onContinue} />}
				{screenIndex === 6 && (
					<ChallengeObConsistency onContinue={onContinue} />
				)}
				{/* {screenIndex === 7 && <ChallengeObAfter onContinue={onContinue} />} */}
				{screenIndex === 7 && (
					<ChallengeObName
						onContinue={onContinue}
						userName={userName}
						setUserName={setUserName}
					/>
				)}
				{screenIndex === 8 && (
					<ChallengeObNumber
						onContinue={onContinue}
						number={number}
						setNumber={setNumber}
					/>
				)}
			</div>
		</div>
	);
};

export default ChallengeOnboarding;
